import axios from 'axios'
import TimeUtil from 'utils/time-util'

const API_PATH = 'admins/marketing/discount_batches'

const MarketingDiscountBatchesApi = {
  /**
   * Get marketing discount batches.
   * Invoke `GET /admins/marketing/disocunt_batches`
   * @param {Object} params - can contain :
      * @param {string} status - `Marketing::DiscountBatches` status
      * @param {string} code - `Marketing::DiscountBatches` code, ex : MKTDISCxx
      * @param {string} start_batch_job_at - `Marketing::DiscountBatches` start_batch_job_at, format : YYYY-MM-DD
      * @param {string} expire_batch_job_at - `Marketing::DiscountBatches` expire_batch_job_at, format : YYYY-MM-DD
      * @param {number} page - page no
      * @param {number} per_page - items shown per page
   */
  get: async (
    params
  ) => {
    const path       = API_PATH
    const api_params = {
      ...params
    }

    const response = axios.get(path, api_params )
    return response
  },
  /**
   * Post data from eligible products table
   * Invoke `POST admins/marketing/discount_batches/schedule_discount
   * @param {Array} products - array of product object
   * @param {String} fileName - name of file uploaded
   * @param {Boolean} isInstant - whether or not instantly applying the discount
   * @param {String} startsAt - starting time for applying discounts
   * @param {Boolean} isManualExpire - whether or not removing the discount manually
   * @param {String} expiresAt - expire time of the applied discounts
   */
  schedule: async ({ products, fileName, isInstant, startsAt, isManualExpire, expiresAt }) => {
    const path             = `${API_PATH}/schedule`
    let start_batch_job_at = null
    if (!isInstant)
    {
      start_batch_job_at = TimeUtil.format(startsAt, 'DD-MM-YYYY HH:mmZ')
    }

    let expire_batch_job_at = null
    if (!isManualExpire) {
      expire_batch_job_at = TimeUtil.format(expiresAt,'DD-MM-YYYY HH:mmZ')
    }

    const body = {
      product_hashes      : products,
      csv_file_name       : fileName,
      start_batch_job_at  : start_batch_job_at,
      expire_batch_job_at : expire_batch_job_at
    }

    const response = await axios.post(path, body)
    return response
  }

}

export default MarketingDiscountBatchesApi
